import React, { useCallback, useEffect, useMemo } from 'react';
import styled from 'styled-components/macro';
import { useDispatch } from 'react-redux';
import Layout from 'components/common/Layout';
import { userActions } from 'store/actions';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import SearchParamsHelper from 'store/helpers/SearchParamsHelper';
import OldCEHelper from 'store/helpers/OldCEHelper';
declare global {
  interface Window {
    google: any;
  }
}
declare const google: any;

/**
 * it doesn't matter if you are already logged in or not, if you comes to /login you will be relogin
 * https://developers.google.com/identity/sign-in/web/sign-in
 * in localstorage
 * {
 *  user: {
 *    token: // token from google
 *  }
 * }
 */

const LoginPage: React.FC = () => {
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stableDispatch = useCallback(dispatch, []);

  const location = useLocation();

  const { fromCE, inbox } = useMemo(
    () => SearchParamsHelper.getCEParams(location),
    [location],
  );

  const fromOldCE = useMemo(
    () => OldCEHelper.isLocationFromOldCE(location),
    [location],
  );

  /**
   * note when fromCE, chrome extension sends
   *  `https://ocps.one-line.com/login?id=${ticketId}&inbox=${email}&fromCE=true`,
   */
  function credentialHandler(response: any) {
    const userData = JSON.parse(
      window.atob(response.credential.split('.')[1]),
    );
    console.info('Email: ' + userData.email); // This is null if the 'email' scope is not present.
    const tokenId = response.credential;
    stableDispatch(
      userActions.login(
        tokenId,
        {
          imageUrl: userData.picture,
          name: userData.name,
          email: userData.email,
        },
        { fromCE, inbox },
      ),
    );
  }

  useEffect(() => {
    google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      callback: credentialHandler,
    });
    google.accounts.id.renderButton(
      document.getElementById('googleBtn'),
      {
        theme: 'outline',
        size: 'large',
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      },
    );

    google.accounts.id.prompt((notification: any) => {
      console.log('on prompt notification', notification);
    });
    // eslint-disable-next-line
  }, [google]);

  return fromOldCE ? (
    <Dialog open={true}>
      <DialogTitle>
        This Chrome Extension is no longer supported
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          OCPS Web Agent Phase II requires the version II chrome
          extension
        </DialogContentText>
      </DialogContent>
    </Dialog>
  ) : (
    <Layout>
      <Wrapper>
        <SSigninButton id="googleBtn" className="clickable" />
      </Wrapper>
    </Layout>
  );
};

export default LoginPage;

const SSigninButton = styled.div`
  width: 220px;
  transform: scale(1.5);
`;
const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
